export default __webpack_public_path__ + "src/images/packages/gocheganas-lodge/78883a1f01941b32adabb3f4c5eda7cd-5.jpeg";